import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from 'components';

const InvoiceBadge = ({ children, type, onClick, style }) => {
  const badgeType = {
    alert: 'draft',
    ao: 'aggregated',
    authorized: 'paid',
    captured: 'paid',
    confirmed: 'pending',
    deactivated: 'deactivated',
    delivered: 'delivered',
    deliveryfee: 'deliveryFee',
    draft: 'draft',
    invalid: 'black',
    manualpay: 'manual-pay',
    autopay: 'auto-pay',
    paid: 'paid',
    pd: 'warning',
    pending: 'pending',
    po: 'warning',
    pod: 'aggregated', // pod = PO Direct
    sd: 'secondary',
    secondary: 'secondary',
    so: 'primary',
    cso: 'orange',
    unpaid: 'pending',
    viewed: 'viewed',
    seller: 'wholesale',
    distributor: 'distributor',
    buyer: 'restaurant',
    consumer: 'consumer',
    retail: 'retail',
    default: 'default',
  }[type.toLowerCase()] || type.toLowerCase();
  return (
    <Badge style={style} type={badgeType} onClick={onClick}>
      {/* Confirmed should be displayed as UNPAID for now */}
      {children === 'CONFIRMED' ? 'UNPAID' : children}
    </Badge>
  );
};

InvoiceBadge.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.shape({}),
};

InvoiceBadge.defaultProps = {
  onClick: null,
  style: {},
};

export default InvoiceBadge;
